import {
  LIST_VIEW_CARD_DATA,
  LIST_VIEW_LOADING,
  LIST_VIEW_OFFSET,
  LIST_VIEW_TOTAL_CARD_COUNT,
  LIST_VIEW_FILTER_CARDS, // New action type
} from "../actions/types";

const initialState = {
  cardData: [],
  isLoading: false,
  offset: 0,
  totalCards: 0,
  filterCards: {
    card_name: localStorage.getItem("listSearchText") || undefined,
    startDate: "",
    endDate: "",
    view_as: Number(localStorage.getItem("listViewAs")) || null,
  },
};

export default function (state = initialState, { payload, type }) {
  switch (type) {
    case LIST_VIEW_CARD_DATA:
      return { ...state, cardData: payload };
    case LIST_VIEW_LOADING:
      return { ...state, isLoading: payload };
    case LIST_VIEW_OFFSET:
      return { ...state, offset: payload };
    case LIST_VIEW_TOTAL_CARD_COUNT:
      return { ...state, totalCards: payload };
    case LIST_VIEW_FILTER_CARDS:
      return { ...state, filterCards: { ...state.filterCards, ...payload } };
    default:
      return state;
  }
};
